import React from "react";

import CommonCenterContainer from "./CommonCenterContainer";
import Spinner from "./Spinner";

const CommonCenterSpinner = (props) => (
    <CommonCenterContainer>
        <Spinner {...props}/>
    </CommonCenterContainer>
);

CommonCenterSpinner.propTypes = Spinner.propTypes;

export default CommonCenterSpinner;
